import React, { useEffect, useState, useCallback, useRef } from 'react';
import { Container, Table } from 'semantic-ui-react';
import { Filter } from './Filter';
import { getURLParameters } from 'utils';
import history from '../../../../services/history';
import { fetch } from 'services/http';
import { numFormat } from '@rededompedro/utils';
import { paramsToSearchURL } from 'utils';

export function ComplianceFiscal(props) {

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const filterRef = useRef(null);

    useEffect(() => {
        const params = history.location.search;
        if (params.trim() !== '') {
            setLoading(true);
            fetch(`/recebiveis/compliance-fiscal${params}`)
                .then((response) => response.json())
                .then((data) => {
                    setData(data);
                    setLoading(false);
                })
                .catch(() => setLoading(false));
        } else {
            filterRef.current.clear();
        }
    }, [props.location.search]);

    const renderTable = useCallback(() => {        
        const params = getURLParameters(props.location.search);
        if (params.agrupar_por === 'unidade') {
            return (
                <Table selectable>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell>Cod. Unidade</Table.HeaderCell>
                            <Table.HeaderCell>Unidade</Table.HeaderCell>
                            <Table.HeaderCell>Valor</Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {loading && (
                            <Table.Row>
                                <Table.Cell colSpan={3}  style={{ padding: '30px 0', textAlign: 'center' }}>Carregando... por favor, aguarde.</Table.Cell>
                            </Table.Row>
                        )}
                        {!loading && data.map((it, i) => (
                            <Table.Row key={i}>
                                <Table.Cell>{it.unidade_cod}</Table.Cell>
                                <Table.Cell>{it.unidade_nome}</Table.Cell>
                                <Table.Cell>R$ {numFormat(it.valor)}</Table.Cell>
                            </Table.Row>
                        ))}
                    </Table.Body>
                    {!loading && data.length > 0 && (
                        <Table.Footer>
                            <Table.Row>
                                <Table.HeaderCell colSpan={2} style={{ textAlign: 'right', fontWeight: 'bold' }}>Total</Table.HeaderCell>
                                <Table.HeaderCell textAlign="left">
                                    <b>R$ {numFormat(data.map((it) => it.valor).reduce((a, b) => a + b))}</b>
                                </Table.HeaderCell>
                            </Table.Row>
                        </Table.Footer>
                    )}
                </Table>
            );
        }

        if (params.agrupar_por === 'cliente') {
            return (
                <Table selectable>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell>Cod. Unidade</Table.HeaderCell>
                            <Table.HeaderCell>Unidade</Table.HeaderCell>
                            <Table.HeaderCell>Cod. Cliente</Table.HeaderCell>
                            <Table.HeaderCell>Cliente</Table.HeaderCell>
                            <Table.HeaderCell>Valor</Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {loading && (
                            <Table.Row>
                                <Table.Cell colSpan={5}  style={{ padding: '30px 0', textAlign: 'center' }}>Carregando... por favor, aguarde.</Table.Cell>
                            </Table.Row>
                        )}
                        {!loading && data.map((it, i) => (
                            <Table.Row key={i}>
                                <Table.Cell>{it.unidade_cod}</Table.Cell>
                                <Table.Cell>{it.unidade_nome}</Table.Cell>
                                <Table.Cell>{it.cliente_cod}</Table.Cell>
                                <Table.Cell>{it.cliente_nome}</Table.Cell>
                                <Table.Cell>R$ {numFormat(it.valor)}</Table.Cell>
                            </Table.Row>
                        ))}
                    </Table.Body>
                    {!loading && data.length > 0 && (
                        <Table.Footer>
                            <Table.Row>
                                <Table.HeaderCell colSpan={4} style={{ textAlign: 'right', fontWeight: 'bold' }}>Total</Table.HeaderCell>
                                <Table.HeaderCell textAlign="left">
                                    <b>R$ {numFormat(data.map((it) => it.valor).reduce((a, b) => a + b))}</b>
                                </Table.HeaderCell>
                            </Table.Row>
                        </Table.Footer>
                    )}
                </Table>
            );
        }

        if (params.agrupar_por === 'tipo_pagamento') {
            return (
                <Table selectable>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell>Cod. Unidade</Table.HeaderCell>
                            <Table.HeaderCell>Unidade</Table.HeaderCell>
                            <Table.HeaderCell>Cartão</Table.HeaderCell>
                            <Table.HeaderCell>Valor</Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {loading && (
                            <Table.Row>
                                <Table.Cell colSpan={4} style={{ padding: '30px 0', textAlign: 'center' }}>Carregando... por favor, aguarde.</Table.Cell>
                            </Table.Row>
                        )}
                        {!loading && data.map((it, i) => (
                            <Table.Row key={i}>
                                <Table.Cell>{it.unidade_cod}</Table.Cell>
                                <Table.Cell>{it.unidade_nome}</Table.Cell>
                                <Table.Cell>{it.forma_pgto}</Table.Cell>
                                <Table.Cell>R$ {numFormat(it.valor)}</Table.Cell>
                            </Table.Row>
                        ))}
                    </Table.Body>
                    {!loading && data.length > 0 && (
                        <Table.Footer>
                            <Table.Row>
                                <Table.HeaderCell colSpan={3} style={{ textAlign: 'right', fontWeight: 'bold' }}>Total</Table.HeaderCell>
                                <Table.HeaderCell textAlign="left">
                                    <b>R$ {numFormat(data.map((it) => it.valor).reduce((a, b) => a + b))}</b>
                                </Table.HeaderCell>
                            </Table.Row>
                        </Table.Footer>
                    )}
                </Table>
            );
        }
    }, [data, loading, props.location.search]);

    const onFilter = useCallback((filterParams) => {
        history.push({ search: paramsToSearchURL(filterParams) });
    }, []);

    return (
        <Container style={{ marginTop: 15, marginBottom: 15 }} fluid>
            <Filter onFilter={onFilter} ref={filterRef} />
            {renderTable()}
        </Container>
    );
}
